<template>
  <div class="home">
    <!-- 欢迎信息 -->
    <div class="welcome-section">
      <h2>欢迎回来，{{ userName }}</h2>
      <p>今天是 {{ currentDate }}</p>
    </div>

    <!-- 数据概览卡片 -->
    <el-row :gutter="20" class="data-overview">
      <el-col :span="6" v-for="(card, index) in dataCards" :key="index">
        <el-card shadow="hover" :body-style="{ padding: '20px' }">
          <div class="data-card">
            <div class="card-icon" :style="{ background: card.color }">
              <i :class="card.icon"></i>
            </div>
            <div class="card-info">
              <div class="card-title">{{ card.title }}</div>
              <div class="card-value">{{ card.value }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 图表区域 -->
    <el-row :gutter="20" class="charts-section">
      <el-col :span="12">
        <el-card shadow="hover">
          <div slot="header">
            <span>近7天出库统计</span>
          </div>
          <outbound-chart :data="weeklyOutbound" />
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="hover">
          <div slot="header">
            <span>待办事项</span>
          </div>
          <div class="todo-list">
            <div v-for="(item, index) in toDo" 
                 :key="'item-' + index" 
                 class="todo-item">
              <div class="todo-time">{{ formatDateTime(item.createdAt) }}</div>
              <div class="todo-link">
                <a href="javascript:void(0)" 
                   @click="handleTodo(item)" 
                   class="todo-text">
                  <i class="el-icon-document"></i>
                  {{ item.processName }}
                  <span class="todo-plan">[{{ IsNullOrEmpty(item.businessInfo) ? '未知审批名称' : item.businessInfo.planName }}]</span>
                </a>
              </div>
            </div>
            <div v-if="!toDo.length" class="empty-text">
              暂无待办事项
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OutboundChart from '@/components/common/OutboundChart.vue'
import request from '@/utils/request'

export default {
  name: 'Home',
  components: {
    OutboundChart
  },
  
  data() {
    return {
      total: 0,
      toDo:[]
    }
  },
  
  computed: {
    ...mapGetters('dashboard', [
      'statistics',
      'warningList',
      'weeklyOutbound'
    ]),
    ...mapGetters('user', [
      'userInfo'
    ]),
    
    userName() {
      return this.userInfo.name || '管理员'
    },
    
    currentDate() {
      return new Date().toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      })
    },
    dataCards() {
      return [
        {
          title: '今日出库',
          value: this.statistics.todayOutbound || '0',
          icon: 'el-icon-sell',
          color: '#409EFF'
        },
        {
          title: '待处理',
          value: this.total || '0',
          icon: 'el-icon-time',
          color: '#E6A23C'
        },
        {
          title: '库存预警',
          value: this.statistics.warningCount || '0',
          icon: 'el-icon-warning',
          color: '#F56C6C'
        },
        {
          title: '商品总数',
          value: this.statistics.totalProducts || '0',
          icon: 'el-icon-goods',
          color: '#67C23A'
        }
      ]
    }
  },
  
  created() {
    this.fetchData()
  },
  
  methods: {
    IsNullOrEmpty(value) {
      return value === null || value === undefined || value === ''
    },
    async fetchData() {
      try {
        // 获取待办事项数据
        const todoRes = await request({
          url: '/api/v1/process/todo',
          method: 'POST',
          data: {
            page: 1,
            size: 7
          }
        })
        console.log("todoRes:",todoRes.status)
        if (todoRes.status === 1) {
         
          this.toDo = todoRes.data.list || []
          this.total = todoRes.data.total || 0
          console.log("toDo:",this.toDo)
        }
        
        // 获取其他仪表盘数据
        await this.$store.dispatch('dashboard/fetchDashboardData')
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      }
    },
    
    formatDateTime(timestamp) {
      if (!timestamp) return '-'
      // 如果是字符串格式的时间，需要先转换
      if (typeof timestamp === 'string') {
        // 处理带有时区的时间格式
        timestamp = timestamp.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
        return timestamp.substring(0, 16) // 只取到分钟
      }
      
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
    
    handleTodo(item) {
      this.$router.push({
        path: '/process/todo',
        query: {
          processId: item.processId,
          nodeId: item.nodeId
        }
      })
    }
  }
}
</script>

<style scoped>
.home {
  padding: 20px;
}

.welcome-section {
  margin-bottom: 30px;
}

.welcome-section h2 {
  margin: 0;
  color: #303133;
}

.welcome-section p {
  margin: 10px 0 0;
  color: #909399;
}

.data-overview {
  margin-bottom: 30px;
}

.data-card {
  display: flex;
  align-items: center;
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.card-icon i {
  font-size: 24px;
  color: #fff;
}

.card-info .card-title {
  font-size: 14px;
  color: #909399;
}

.card-info .card-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-top: 5px;
}

.charts-section {
  margin-bottom: 20px;
}

.chart-placeholder {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #909399;
}

.warning-text {
  color: #F56C6C;
}

.el-card :deep(.el-card__header) {
  padding: 15px 20px;
}

.charts-section .el-card {
  margin-bottom: 20px;
}

.todo-list {
  padding: 0 10px;
  
  .todo-item {
    padding: 12px 0;
    border-bottom: 1px solid #EBEEF5;
    display: flex;
    align-items: center;
    
    &:last-child {
      border-bottom: none;
    }
  }
  
  .todo-time {
    color: #909399;
    font-size: 13px;
    width: 140px;
    flex-shrink: 0;
  }
  
  .todo-link {
    flex: 1;
    
  }
  
  .todo-text {
    color: #409EFF;
    text-decoration: none;
    font-size: 14px;
    display: flex;
    align-items: center;
    
    &:hover {
      color: #66b1ff;
    }
    
    i {
      margin-right: 5px;
      font-size: 16px;
    }
  }
  
  .todo-plan {
    color: #606266;
    margin-left: 5px;
  }
  
  .empty-text {
    color: #909399;
    text-align: center;
    padding: 30px 0;
    font-size: 14px;
  }
}
</style> 